import React from 'react';
import { IClinic } from 'model/v2';
import RemoveIcon from 'assets/img/remove-btn.svg';

interface Props {
  selectedClinicsList: number[];
  allClinicsMap: Map<number, IClinic>;
  onClearSelectedList: () => void;
  onRemoveClinic: (id: number) => void;
}

const SelectedClinics = ({
  selectedClinicsList,
  allClinicsMap,
  onClearSelectedList,
  onRemoveClinic
}: Props) => {
  return (
    <>
      <div>
        <span className="clear-list" onClick={onClearSelectedList}>
          Clear List
        </span>
      </div>
      {selectedClinicsList.map(id => {
        return (
          <div className="row-position" key={id}>
            <label>
              {allClinicsMap.get(id)?.name}, (
              {allClinicsMap.get(id)?.abbreviation || ''})
            </label>
            <img
              alt="remove"
              src={RemoveIcon}
              width={19}
              style={{ padding: '5px', marginBottom: '2px', cursor: 'pointer' }}
              onClick={() => onRemoveClinic(id)}
            />
          </div>
        );
      })}
    </>
  );
};
export default React.memo(SelectedClinics);
